import { useState } from "react";
import { useNavigate } from "react-router";
import { SalesCreateDraftDialog } from "../components/sowingInstructions/PhaseWorkflowDialogs";
import { Button } from "@/components/ui/button";

export const CreateSowingInstructionPage = () => {
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(true);

  const handleSuccess = () => {
    navigate("/production/manage-instructions");
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Create Sowing Instruction</h1>
        <p className="text-muted-foreground mt-1">
          Create a new sowing instruction for the Sowing Supervisor to review.
        </p>
      </div>

      {!dialogOpen && (
        <div className="flex gap-3">
          <Button onClick={() => setDialogOpen(true)}>Create Another</Button>
          <Button variant="outline" onClick={() => navigate("/production/manage-instructions")}>
            View All Instructions
          </Button>
        </div>
      )}

      <SalesCreateDraftDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        onSuccess={handleSuccess}
      />
    </div>
  );
};
